var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12061 15.9498C4.12061 15.556 4.43981 15.2368 4.83357 15.2368H13.3891C13.7829 15.2368 14.1021 15.556 14.1021 15.9498C14.1021 16.3435 13.7829 16.6627 13.3891 16.6627H4.83357C4.43981 16.6627 4.12061 16.3435 4.12061 15.9498Z",
    fill: "#33383F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83357 2.40332C5.22733 2.40332 5.54653 2.72252 5.54653 3.11628V8.81999C5.54653 10.7888 7.14255 12.3848 9.11135 12.3848C11.0801 12.3848 12.6762 10.7888 12.6762 8.81999V3.11628C12.6762 2.72252 12.9954 2.40332 13.3891 2.40332C13.7829 2.40332 14.1021 2.72252 14.1021 3.11628V8.81999C14.1021 11.5763 11.8677 13.8107 9.11135 13.8107C6.35504 13.8107 4.12061 11.5763 4.12061 8.81999V3.11628C4.12061 2.72252 4.43981 2.40332 4.83357 2.40332Z",
    fill: "#33383F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/underline_icon.b373379405c8056105379049d05da93a.svg";
export { ForwardRef as ReactComponent };